import { logoutUser } from '@ports/common/sessionStateSlice';
import { persister, store } from '@ports/common/store';
import { signOut, forgetDevice } from 'aws-amplify/auth';
import { setIsAuthenticated } from '@ports/common/authStateSlice';
import { resetUserData } from '@ports/common/userStateSlice';
import localforage from 'localforage';
import { apiSlices } from '../getState';

export const clearCache = async (dispatch: any) => {
  await apiSlices?.forEach((api: any) => {
    dispatch(api?.util?.resetApiState());
  });
};

export const signOutHandler = async (dispatch: any, navigate: any) => {
  try {
    // Check if rememberMe was enabled during this session
    const rememberMe = store?.getState()?.authStateSlice?.rememberMe;

    // Only forget devices if rememberMe was NOT checked
    if (!rememberMe) {
      try {
        await forgetDevice();
        console.log(
          'Current device forgotten on logout (rememberMe was false)'
        );
      } catch (deviceError) {
        console.warn('Failed to forget current device:', deviceError);
      }
    } else {
      console.log('Current device kept (rememberMe was true)');
    }

    await signOut();
    dispatch(logoutUser());
    dispatch(setIsAuthenticated({ isAuthenticated: false }));
    dispatch(resetUserData());
    sessionStorage.clear();
    await purgeStore();
    await localforage.clear();
    navigate('/');
  } catch (error) {
    console.error('Error during sign out:', error);
    navigate('/');
  }
};

async function purgeStore() {
  try {
    // First pause the persistor to prevent any ongoing operations
    persister?.pause();

    // Wait a moment for any pending operations to complete
    await new Promise(resolve => setTimeout(resolve, 100));

    // Purge the persisted state
    await persister?.purge();

    // Resume the persistor
    persister?.persist();
  } catch (error) {
    console.error('Error during persistor purge:', error);
    // If purging fails, try to at least resume the persistor
    try {
      persister?.persist();
    } catch (resumeError) {
      console.error(
        'Error resuming persistor after failed purge:',
        resumeError
      );
      // Silently handle resume error
    }
  }
}
